import { createUseStyles } from 'react-jss';
import AppBackground from 'assets/images/app-background.svg';
import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows, breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

/** @deprecated Use `styled-components` directly instead of `createUseStyles`. */
const styles = {
  spinnerWrapper: {
    width: '100vw',
    height: '100vh',
  },
  appWrapper: {
    padding: '3rem',
    backgroundImage: `url(${AppBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: '3.4rem',
    textAlign: 'center',
    margin: '0 0 2rem',
    [breakpoints.sm.down]: {
      fontSize: '2.8rem',
    },
  },
  formWrapper: {
    // Layout
    maxWidth: '48rem',
    maxHeight: '80vh',
    minHeight: '40rem',
    padding: '3.8rem',
    margin: '0 auto',
    overflowY: 'auto',
    position: 'relative',
    boxSizing: 'border-box',
    // Styles
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    boxShadow: boxShadows.light[8],
    border: '0.2rem solid #A0C4FB',

    [breakpoints.sm.down]: {
      padding: '2.8rem',
      maxHeight: '100%',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };

export const GeneralTitleStyled = styled.h1`
  font-size: 3.4rem;
  text-align: center;
  margin: 0 0 2rem;

  @media (width <= 640px) {
    font-size: 2.8rem;
  }
`;
